<div
  class="coverage-summary"
  [class.coverage-summary--complete]="summaryState() === 'data' && !hasPendency()"
  [class.coverage-summary--empty]="summaryState() === 'empty'">
  @if (summaryState() === 'loading') {
    <div class="coverage-summary__loading">
      <app-cog-loading-spinner [size]="32" />
      <p class="coverage-summary__loading-label">Carregando cobertura...</p>
    </div>
  } @else {
    <div class="coverage-summary__top">
      <div class="coverage-summary__headline-block">
        <p class="coverage-summary__headline">{{ headline() }}</p>
        @if (subtitle()) {
          <p class="coverage-summary__subtitle">{{ subtitle() }}</p>
        }
      </div>

      <div class="coverage-summary__toggle" role="group" aria-label="Modo de visualização">
        <button
          type="button"
          class="coverage-summary__toggle-button"
          [class.coverage-summary__toggle-button--active]="viewMode() === 'cartoes'"
          (click)="setViewMode('cartoes')">
          Cartões
        </button>
        <button
          type="button"
          class="coverage-summary__toggle-button"
          [class.coverage-summary__toggle-button--active]="viewMode() === 'regua'"
          (click)="setViewMode('regua')">
          Régua
        </button>
      </div>
    </div>

    @if (summaryState() === 'data') {
      <div class="coverage-summary__progress-track">
        <div class="coverage-summary__progress-fill" [style.width.%]="completionPercent()"></div>
      </div>

      <div class="coverage-summary__pendency">
        <span class="coverage-summary__pendency-label">
          {{ hasPendency() ? 'Pendências:' : 'Nada pendente — cobertura completa.' }}
        </span>

        @if (hasPendency()) {
          <div class="coverage-summary__chips">
            @for (chip of pendencyChips(); track trackChip(chip)) {
              <button
                type="button"
                class="coverage-summary__chip"
                [class.coverage-summary__chip--rejected]="chip.kind === 'rejected'"
                [class.coverage-summary__chip--analyzing]="chip.kind === 'analyzing'"
                (click)="onChipClick(chip)">
                {{ chip.label }}
              </button>
            }
          </div>
        }
      </div>
    }
  }
</div>
